import { useGetUserSeatsAddOnData } from './use-get-user-seats-addon-data';

/**
 * Returns the # of "additional" user seats (above the billingPlan's included user seat limit)
 * @returns {number} default return is `0`
 */
export const useGetNumberOfExtraUserSeats = () => {
  const userAddOnData = useGetUserSeatsAddOnData();
  const numberOfAddOnUserSeats = userAddOnData?.quantity ?? 0;

  return numberOfAddOnUserSeats;
};
